var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1503 3.73496C16.1576 3.89996 16.1576 4.05747 16.1576 4.22247C16.1649 9.22498 12.4509 15 5.65881 15C3.65557 15 1.68887 14.4075 0 13.2975C0.292445 13.335 0.58489 13.35 0.877336 13.35C2.53696 13.35 4.15272 12.78 5.46141 11.7225C3.88221 11.6925 2.4931 10.635 2.01056 9.08998C2.56621 9.20248 3.13647 9.17998 3.6775 9.02248C1.95938 8.67748 0.723802 7.12498 0.716491 5.31747C0.716491 5.30247 0.716491 5.28747 0.716491 5.27247C1.22827 5.56497 1.80585 5.72997 2.39074 5.74497C0.77498 4.63497 0.270512 2.42246 1.2502 0.689954C3.12916 3.05996 5.89277 4.49247 8.86109 4.64997C8.56133 3.33746 8.97076 1.95746 9.92851 1.02746C11.4127 -0.405049 13.7522 -0.330049 15.156 1.19246C15.9821 1.02746 16.779 0.712454 17.5028 0.269953C17.225 1.14746 16.6474 1.88996 15.8798 2.36246C16.6109 2.27246 17.3274 2.06996 18 1.76996C17.5028 2.53496 16.8741 3.19496 16.1503 3.73496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.7efea00f71506e8d297ca8957a3de0a0.svg";
export { ForwardRef as ReactComponent };